<template>
  <div class="import-buttons">
    <import-csv-button :buttonClass="buttonClass" @data="handleData($event)"></import-csv-button>
    <import-cloud-sponge-button
      :buttonClass="buttonClass"
      :source="source.source"
      :label="source.label"
      :icon="source.icon"
      @data="handleData($event)"
      v-for="source in cloudSpongeSources"
      :key="source.source"></import-cloud-sponge-button>
  </div>
</template>
<script>
import ImportCsvButton from './ImportCsvButton.vue'
import ImportCloudSpongeButton from './ImportCloudSpongeButton.vue'

export default {
  components: {
    ImportCloudSpongeButton,
    ImportCsvButton
  },
  data () {
    return {
      buttonClass: 'import-button',
      cloudSpongeSources: [
        { source: 'gmail', label: 'Sign in with Google', icon: 'google' },
        { source: 'linkedin', label: 'Sign in with LinkedIn', icon: 'linkedin' },
        { source: 'addressbook', label: 'Upload Address Book', icon: 'address-book' },
        { source: 'outlook', label: 'Sign in with Outlook', icon: 'outlook' },
        { source: 'iCloud', label: 'Sign in with iCloud', icon: 'icloud' },
        { source: 'yahoo', label: 'Sign in with Yahoo!', icon: 'yahoo' }
      ]
    }
  },
  methods: {
    handleData (data) {
      this.$emit('data', data)
    }
  }
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@500&display=swap');

  .import-buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .import-button {
    display: flex;
    align-items: center;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    width: 205px;
    padding: 12px 16px 12px 0;
    margin: 9px 0;
    transition: background-color .3s, box-shadow .3s;
    border: none;
    border-radius: 3px;
    box-shadow: 0 -1px 0 rgba(0, 0, 0, .04), 0 1px 1px rgba(0, 0, 0, .25);
    color: #757575;

    &:hover {
      box-shadow: 0 -1px 0 rgba(0, 0, 0, .04), 0 2px 4px rgba(0, 0, 0, .25);
    }

    img {
      height: 18px;
      width: 18px;
      margin-left: 8px;
      margin-right: 24px;
    }
  }
</style>
